// extracted by mini-css-extract-plugin
export var formContainer = "_lc-0";
export var message = "_lc-1";